import { staticFile } from '@common/utils'
import BackgroundImageComponent from '@components/common/background-image'

type TimelineCardProps = {
  description: string
  background: string
  session: number
  date: string
}

const BackgroundImage = (): JSX.Element => (
  <>
    <BackgroundImageComponent
      image="/images/shaastra-upskill-teacher-mentoring-program/timeline/left-shapes.svg"
      top={2}
      left={0}
      zIndex={0}
    />
    <BackgroundImageComponent
      image="/images/shaastra-upskill-teacher-mentoring-program/timeline/right-shapes.svg"
      top={2}
      right={0}
      zIndex={0}
    />
  </>
)

export const TimelineCard = ({
  background,
  description,
  session,
  date,
}: TimelineCardProps): JSX.Element => {
  const orangeCardStyle = {
    background:
      'linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 69.79%), #FF5A43',
    border: '1px solid #FF5A43',
    boxShadow: '0px 4px 26px rgba(0, 0, 0, 0.1)',
  }
  const violetCardStyle = {
    background:
      'linear-gradient(82.95deg, #BF3240 -6.56%, #7E36D9 122.43%), #FF5A43',
    boxShadow: '0px 4px 26px rgba(0, 0, 0, 0.1)',
  }
  return (
    <div
      className="flex flex-col align-center justify-center text-center lg:w-1/3 rounded-lg my-5 lg:my-0"
      style={background === 'orange' ? orangeCardStyle : violetCardStyle}
    >
      <div className="flex pt-4">
        <p
          className={`font-700 text-white text-xl px-8 h-12 py-2 rounded-r-2xl ${
            background === 'orange' ? 'bg-orange' : 'bg-violet-100'
          }`}
        >
          Session {session}
        </p>
        <p
          className={`ml-auto bg-white text-xl mr-6 px-4 w-24 font-700 rounded-lg ${
            background === 'orange' ? 'text-orange' : 'text-violet-100'
          }`}
        >
          {date} <br />4 PM
        </p>
      </div>
      <div className="pb-8 lg:px-12">
        <img
          className="mx-auto"
          src={staticFile(
            '/images/shaastra-upskill-teacher-mentoring-program/timeline/illustration.svg'
          )}
          alt="Illustration"
        />
        <p className="text-white text-lg font-600 mt-8">{description}</p>
      </div>
    </div>
  )
}

const Timeline = (): JSX.Element => {
  return (
    <div className="relative flex flex-col px-10 lg:px-56 xl:px-20 mx-auto lg:space-y-10 lg:my-40">
      <BackgroundImage />
      <div className="relative flex flex-col z-10 lg:space-x-10 lg:flex-row">
        <TimelineCard
          description="This will be an introductory session highlighting the basics of Scratch programming"
          date="16th Jan'21"
          background="orange"
          session={1}
        />
        <TimelineCard
          description="The teachers would be introduced to control and operator blocks"
          date="23rd Jan'21"
          background="orange"
          session={2}
        />
        <TimelineCard
          description="Learn the application &#38; implementation of AI in Scratch"
          date="30th Jan'21"
          background="orange"
          session={3}
        />
      </div>
      <div className="relative flex flex-col z-10 lg:pt-20 lg:space-x-10 lg:flex-row">
        <TimelineCard
          description="Introduction to functions and variables in Scratch"
          date="31st Jan'21"
          background="violet"
          session={4}
        />
        <TimelineCard
          description="Extension of learning about the block concept &#38; creating your own sprites"
          date="6th Feb'21"
          background="violet"
          session={5}
        />
        <TimelineCard
          description="Revisit all the concepts taught &#38; introduction to the concept of cloning"
          date="13th Feb'21"
          background="violet"
          session={6}
        />
      </div>
    </div>
  )
}

export default Timeline
